

function animateProjects() {
  $('.block-project').each(function(index) {
    animateProject(this);
  });
}

function animateProject(project) {
  var $this = $(project);

  var $projectImage       = $this.find(".block-media");
  var $projectBlockContent     = $this.find(".block-content");
  var $projectTag         = $this.find(".project-tag");
  var $projectTitle       = $this.find("h3");
  var $projectSubTitle       = $this.find("h4");
  var $projectContent       = $this.find(".project-content");
  var $projectCta       = $this.find(".btn-discover");

  var blocksTL      = new TimelineLite({
    paused: true
  });

  TweenMax.set($projectImage, {opacity: 0});
  TweenMax.set($projectBlockContent, {y: 140});
  TweenMax.set($projectTag, {x: -50, opacity: 0});
  TweenMax.set($projectTitle, {x: -50, opacity: 0});
  TweenMax.set($projectSubTitle, {x: -50, opacity: 0});
  TweenMax.set($projectContent, {x: -50, opacity: 0});
  TweenMax.set($projectCta, {y: -20, opacity: 0});

  new ScrollMagic.Scene({triggerElement: project, triggerHook: 0.75, offset: 0, duration: "50%"})
  .setTween($projectImage, {opacity: 1, ease: Linear.easeNone})
  .addTo(controller);

  new ScrollMagic.Scene({triggerElement: project, triggerHook: 1, offset: 0, duration: "100%"})
  .setTween($projectBlockContent, {y: 0, ease: Linear.easeNone})
  .addTo(controller);

  var projectTL  = new TimelineLite({paused: true});

  projectTL.to($projectTag, 0.75, { x: 0, opacity: 1, ease: Power4.easeOut })
           .to($projectTitle, 0.75, { x: 0, opacity: 1, ease: Power4.easeOut }, 0.5)
           .to($projectSubTitle, 0.75, { x: 0, opacity: 1, ease: Power4.easeOut }, 0.75)
           .to($projectContent, 0.75, { x: 0, opacity: 1, ease: Power4.easeOut }, 0.9)
           .to($projectCta, 0.3, { y: 0, opacity: 1, ease: Back.easeOut }, 1.0);

  var scene = new ScrollMagic.Scene({
    triggerElement: project,
    triggerHook: 0.75,
    offset: 0
  })
  .on('enter', function (event) {
    projectTL.play().timeScale(1);
  })
  .on('leave', function (event) {
    projectTL.reverse().timeScale(1.5);
  })
  .addTo(controller);
}